
import React from 'react';
import { MapPin, Info } from 'lucide-react';
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { getScoreColorClass, getScoreText } from '@/utils/propertyScoreCalculator';

interface PropertySummaryProps {
  property: {
    title?: string;
    tipo?: string;
    finalidade?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
    location?: string;
  };
  score: number;
}

const PropertySummary: React.FC<PropertySummaryProps> = ({ property, score }) => {
  // Generate a title if one isn't provided directly
  const title = property.title || 
    `${property.tipo || 'Imóvel'} em ${property.bairro || ''}`;
  
  // Generate a location string if one isn't provided directly
  const location = property.location || 
    [property.bairro, property.cidade, property.estado]
      .filter(Boolean)
      .join(', ');
  
  const scoreColor = getScoreColorClass(score);
  const scoreText = getScoreText(score);

  return (
    <div className="mb-8">
      <h1 className="text-3xl font-bold mb-2">{title}</h1>
      {location && (
        <div className="flex items-center text-gray-600 mb-4">
          <MapPin size={18} className="mr-1" />
          <span>{location}</span>
        </div>
      )}
      <div className="flex items-center">
        <div className={`text-4xl font-bold ${scoreColor} mr-2`}>{score}</div>
        <div className="text-lg font-medium text-gray-700">/ 100</div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none">
                <Info size={18} />
              </button>
            </TooltipTrigger>
            <TooltipContent className="bg-white p-3 max-w-xs text-sm">
              <p>
                A pontuação é calculada com base em:
                <br /><br />
                • 50% - Preço por m² em relação à média
                <br />
                • 20% - Preço em relação à média do bairro
                <br />
                • 20% - Proporção entre pontos fortes e fracos
                <br />
                • 10% - Características especiais do imóvel
                <br /><br />
                <span className="font-medium">80-100:</span> Considere o investimento, ele está acima da média.
                <br />
                <span className="font-medium">60-79:</span> Bom potencial, vale explorar mais detalhes.
                <br />
                <span className="font-medium">0-59:</span> Avalie com cautela, pode exigir negociação.
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <div className="ml-3 px-3 py-1 bg-blue-light/10 text-blue-dark rounded-full text-sm">
          {scoreText}
        </div>
      </div>
    </div>
  );
};

export default PropertySummary;
